var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListsFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.38201 2.4359C5.6164 1.6072 6.37831 1 7.28205 1H8.71795C9.62169 1 10.3836 1.6072 10.618 2.4359H11.5897C12.6802 2.4359 13.5641 3.31985 13.5641 4.41026V13.0256C13.5641 14.116 12.6802 15 11.5897 15H4.41026C3.31985 15 2.4359 14.116 2.4359 13.0256V4.41026C2.4359 3.31985 3.31985 2.4359 4.41026 2.4359H5.38201ZM5.38201 3.51282H4.41026C3.91462 3.51282 3.51282 3.91462 3.51282 4.41026V13.0256C3.51282 13.5213 3.91462 13.9231 4.41026 13.9231H11.5897C12.0854 13.9231 12.4872 13.5213 12.4872 13.0256V4.41026C12.4872 3.91462 12.0854 3.51282 11.5897 3.51282H10.618C10.3836 4.34151 9.62169 4.94872 8.71795 4.94872H7.28205C6.37831 4.94872 5.6164 4.34151 5.38201 3.51282ZM7.28205 2.07692C6.78641 2.07692 6.38462 2.47872 6.38462 2.97436C6.38462 3.47 6.78641 3.87179 7.28205 3.87179H8.71795C9.21359 3.87179 9.61539 3.47 9.61539 2.97436C9.61539 2.47872 9.21359 2.07692 8.71795 2.07692H7.28205Z",
    fill: "#5E6C84",
    stroke: "#5E6C84",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListsFilter);
export default __webpack_public_path__ + "static/media/listsFilter.9f328fda4d4608dd272cfed9a3dab412.svg";
export { ForwardRef as ReactComponent };